import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home.vue";
import { getOldUrl } from "@/network/home.js";
import store from "@/store";

// const Feature = () => import("../views/feature/Feature.vue")
Vue.use(VueRouter);

const routes = [
  { path: '*', redirect: '/' },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: 'Home',
    }
  },
  
  {
    path: "/feature",
    name: "Feature",
    component: () => import("../views/feature/Feature.vue"),
    meta: {
      title: 'COLUMN'
    }
  },
  {
    path: "/share",
    name: "Share",
    component: () => import("../components/common/model/share.vue")
  },
  {
    path: "/detail",
    name: "Detial",
    component: () => import("../views/detial/Detial.vue"),
    meta: {
      metaInfo: {
        title: "detail",
        keywords: "vuex,vue-route",
        description: "this is detail page",
        url: ""
      }
    }
  },
  {
    path: "/live",
    name: "Live",
    component: () => import("../views/live/Live.vue"),
    meta: {
      metaInfo: {
        title: "Live",
        keywords: "vuex,vue-route",
        description: "this is Live page",
        url: ""
      }
    }
  },
  {
    path: "/mobiledetail",
    name: "MobileDetail",
    component: () => import("../views/previewDetial/Detial.vue")
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("../views/advancedsearch/AdvancedSearch.vue")
  },
  {
    path: "/video",
    name: "Vedio",
    component: () => import("../views/vedio/Vedio.vue")
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/news/News.vue")
  },
  {
    path: "/featuredetail",
    name: "FeatureDetail",
    component: () => import("../views/featuredetail/FeatureDetail.vue")
  },
  {
    path: "/poster",
    name: "Poster",
    component: () => import("../views/detial/Poster.vue")
  },
  {
    path: "/joinus",
    name: "joinus",
    component: () => import("../views/joinUs.vue")
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: () => import("../views/aboutUs.vue")
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact.vue")
  },
  {
    path: "/guidePage",
    name: "GuidePage",
    component: () => import("../views/GuidePage.vue")
  }

];




const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: '',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }

});

router.beforeEach((to, from, next) => {
  store.dispatch('getWebConfig')
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next();
})



export default router;
